<template>
    <div class="file-uploader">
        <div v-if="! uploader.status.uploading" class="uploader">
            <div class="drop-area"
                 :class="{'is-dragging': uploader.dragging}"
                 @click.prevent.stop="$refs.input.click()"
                 @drop.prevent.stop="drop"
                 @dragover.prevent.stop="dragging"
                 @dragenter.prevent.stop="dragging"
                 @dragend.prevent.stop="dragend"
                 @dragleave.prevent.stop="dragend">

                <lottie-animation class="animation"
                                  :loop="true"
                                  :animation-data="require('@/Animations/Canvas2/upload-files-animation.json')"/>

                <div class="info">
                    Drag and drop files here or click this area to upload
                </div>
            </div>
            <div v-if="uploader.file" class="uploaded mt-3" @click.prevent.stop>
                <file-preview :file="uploader.file"/>
            </div>
        </div>
        <div v-else class="uploading">
            <lottie-animation class="animation"
                              :loop="true"
                              :animation-data="require('@/Animations/Canvas2/uploading.json')"/>
        </div>

        <input ref="input" class="d-none" type="file" @change="fileChanged">

    </div>
</template>

<script>
import {LottieAnimation} from "lottie-web-vue";
import API from "@/API";
import FilePreview from "@/Components/Common/FilePreview";
export default {
    name: "FileUploader",
    components: {FilePreview, LottieAnimation},
    emits: ['update:modelValue', 'change', 'uploadstart', 'uploadend'],

    props: {

        modelValue: {
            type: Object,
            default: null,
        },

        path: {
            type: String,
            default: 'public-uploads',
        },
    },

    data(){
        return {
            uploader: {
                file: null,
                dragging: false,
                status: {
                    uploading: false,
                    progress: 0,
                }
            },

        }
    },

    methods: {
        dragging(){
            this.uploader.dragging = true;
        },

        dragend(){
            this.uploader.dragging = false;
        },

        drop(ev){
            this.dragend();
            this.upload( ev.dataTransfer.files );
        },

        fileChanged(ev){
            this.upload( ev.target.files );
        },

        async upload(files){

            if( files && files.length ){

                this.uploader.status.uploading = true;
                this.$emit('uploadstart');

                try {

                    const uploaded = await API.uploads.store(files[0], this.path, {
                        onUploadProgress: (ev) => {
                            const total = ev.lengthComputable ? ev.total : ev.target.getResponseHeader('content-length') || ev.target.getResponseHeader('x-decompressed-content-length');
                            if (total !== null) {
                                this.uploader.status.uploading = true;
                                this.uploader.status.progress = Math.round((ev.loaded * 100) / total);
                            }
                        }
                    });

                    this.uploader.file = uploaded?.file;
                    this.$refs.input.value = null;

                    this.$emit('update:modelValue', this.uploader.file);
                    this.$emit('change', this.uploader.file);

                }catch (e){}

                this.uploader.status.uploading = false;
                this.uploader.status.progress = 0;
                this.$emit('uploadend');
            }
        },
    },

    mounted() {
        this.uploader.file = this.modelValue;
    },

}
</script>

<style lang="scss" scoped>
.drop-area{
    padding: 2rem 2rem;
    background: #F7F9FA;
    border: #A5F8FC solid 1px;
    transition: all .3s;
    cursor: pointer;
    user-select: none;

    &:hover{
        background-color: darken(#F7F9FA, 15%);
    }

    &.is-dragging{
        background: darken(#F7F9FA, 5%);
        box-shadow: rgb(0 0 0 / 10%) 0 0 15px inset;
        border: #15d2ec solid 5px;
    }

    .info{
        text-align: center;
        color: #656565;
    }
}

.animation{
    display: block;
    margin: 1rem auto;
    width: 100px;
    height: auto;
}
</style>
